<svelte:component
  this={template.plugin(render, node)}
  {...template.pluginProps(render, node)}
/>

<script>
  import { getContext } from 'svelte'

  export let node
  export let render

  const platform = getContext('platform')
  const { template } = platform.api.core
</script>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>